/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context as StoreUserContext } from '../../../../../providers/StoreUserContextProvider';
import WsDesignCard from '../../sections/designGrid/WsDesignCard';
import { getSelectedResourceBaseNavigationUrl } from '../../../../../helpers/webstoreHelper';

const WsDesignBlock = ({
  config,
  baseStoreUrl,
  onNavigate,
  colorScheme,
  portraitRatio,
  resourceNavigation,
  ...rest
}) => {
  const { state } = useContext(StoreUserContext);
  const ecomStoreDesign = state.ecomStoreDesigns.value.find(
    (c) =>
      c.pkEcomVendorDesign.toString() === config.ecomStoreDesign?.toString()
  );
  const designNotFound = state.ecomStoreDesigns.idsNotFound.includes(
    config.ecomStoreDesign?.toString()
  );
  const baseResourceUrl = `${baseStoreUrl}${getSelectedResourceBaseNavigationUrl(
    resourceNavigation,
    'designs'
  )}`;

  return (
    <WsDesignCard
      baseStoreUrl={baseResourceUrl}
      colorScheme={colorScheme}
      ecomStoreDesign={ecomStoreDesign}
      noDesign={(config && !config.ecomStoreDesign) || designNotFound}
      onNavigate={onNavigate}
      portraitRatio={portraitRatio}
      {...rest}
    />
  );
};

WsDesignBlock.propTypes = {
  baseStoreUrl: PropTypes.string,
  colorScheme: PropTypes.object,
  config: PropTypes.object,
  onNavigate: PropTypes.func,
  portraitRatio: PropTypes.bool,
  resourceNavigation: PropTypes.array
};

export default WsDesignBlock;
